import { Component, OnInit, Input, ViewChild, ElementRef, ChangeDetectionStrategy } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'ep-svg-icon',
    templateUrl: './svg-icon.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./svg-icon.component.scss']
})

export class SvgIconComponent implements OnInit {

    constructor(private sanitizer: DomSanitizer) { }

    @Input() extraClasses: string;
    @Input() icon: string;

    @ViewChild('svgContainer', { static: true }) svgContainer: ElementRef;

    public svgHtml: string;
    public classes = '';
    public sanitizedSvg: SafeHtml;
    public viewbox = null;

    ngOnInit(): void {
        this.classes = 'icon icon-' + this.icon;
        if (this.extraClasses) {
            this.classes += ' ' + this.extraClasses;
        }

        //if not menu set viewbox model default value, anglar provide angular svg component, so we can implement that in the future
        if (this.icon.indexOf('menu') === -1) {
            this.viewbox = '0 0 24 24';
        }

        if (this.icon === 'info' || this.icon === 'circle-chevron-left') {
            this.viewbox = '0 0 32 32';
        }

        if (this.icon === 'info-circle') {
            this.viewbox = '0 0 24 28';
        }

        let useTag = `<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/css/svg/icons.svg#${this.icon}"></use>`;
        this.sanitizedSvg = this.sanitizer.bypassSecurityTrustHtml(useTag);
    }
}
